import 'normalize.css';
import { ToastContainer } from 'react-toastify';
import { StoreProvider } from '~/store';
import './GlobalStyle.css';
import './animate.css';
// import Logic from '../logic/Logic';

function GlobalStyle({ children }) {
    return (
        <StoreProvider>
            {children}
            <ToastContainer
                position="bottom-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            {/* <Logic /> */}
        </StoreProvider>
    );
}

export default GlobalStyle;
